// extracted by mini-css-extract-plugin
export var footer = "_pk-0";
export var inherit = "_pk-1";
export var input = "_pk-2";
export var modalContent = "_pk-3";
export var quillEditor = "_pk-4";
export var subtitle = "_pk-5";